import { react2angular } from 'react2angular';
import MuiNativeSelect from './index';

export const MuiNativeSelectModule = angular
  .module('app.components.muiNativeSelect', [])
  .component('muiNativeSelect', react2angular(MuiNativeSelect, [
    'autoComplete',
    'error',
    'handleSelectBlur',
    'handleSelectChange',
    'id',
    'label',
    'options',
    'placeholder',
    'type',
    'value'
  ])).name;



// WEBPACK FOOTER //
// ./src/app/admin/components/NativeSelect/MuiNativeSelect.ng.js